import PropTypes from 'prop-types'
import LazyLoad from 'react-lazyload'

const AssistedSaleProductContent = ({ picture, badge, url }) => {
  const renderBadge = badge => {
    const { type = '', label } = badge

    return (
      <div className={`assisted-sale-product-badge ${type}`}>{label}</div>
    )
  }

  return (
    <div className="assisted-sale-thumbnail-content">
      <a href={url}>
        <LazyLoad offset={200} once>
          <img className="product-thumbnail" src={picture} />
        </LazyLoad>
      </a>
      { badge && renderBadge(badge) }
    </div>
  )
}

AssistedSaleProductContent.propTypes = {
  picture: PropTypes.string,
  badge: PropTypes.shape({
    type: PropTypes.string,
    value: PropTypes.string
  })
}

export default AssistedSaleProductContent
